import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/client';
import { useAuth } from '../../context/AuthContext';

const STORAGE_KEY = 'tr_visitor_tickets';

function readStoredTickets() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export default function VisitorPortal() {
  const { user, logout } = useAuth();
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    setRecent(readStoredTickets());
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/locations');
        setLocations(data.locations || []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div style={{ maxWidth: 960, margin: '0 auto', padding: '1.5rem' }}>
      <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem', marginBottom: '2rem' }}>
        <div>
          <h1 style={{ margin: 0 }}>Welcome{user?.name ? `, ${user.name}` : ''}</h1>
          <p style={{ color: 'var(--text-muted)', margin: '0.35rem 0 0' }}>Find a QR code on-site, or pick a location below to raise a ticket.</p>
        </div>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <Link to="/" className="tr-btn tr-btn-outline">
            Home
          </Link>
          <button type="button" className="tr-btn tr-btn-ghost" onClick={logout}>
            Log out
          </button>
        </div>
      </header>

      <div className="tr-card" style={{ padding: '1.25rem', marginBottom: '1.5rem' }}>
        <h2 style={{ marginTop: 0, fontSize: '1.1rem' }}>How to use</h2>
        <ol style={{ margin: 0, paddingLeft: '1.25rem', color: 'var(--text-muted)', lineHeight: 1.7 }}>
          <li>Look for Ticket Rising QR codes around the campus.</li>
          <li>Scan with your phone camera to open the ticket form for that spot.</li>
          <li>Or choose a location below if you are browsing from this device.</li>
          <li>Submit details, priority, and a rating—we will route it to the right team.</li>
        </ol>
      </div>

      <h2 style={{ fontSize: '1.15rem' }}>Active locations</h2>
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
          <div className="tr-spinner" />
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '1rem' }}>
          {locations.map((loc) => (
            <Link key={loc.id} to={`/ticket/${loc.id}`} className="tr-card" style={{ padding: '1.25rem', textDecoration: 'none', color: 'inherit' }}>
              <h3 style={{ margin: '0 0 0.35rem', color: 'var(--primary)' }}>{loc.name}</h3>
              <div style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>
                {loc.floor} · {loc.building}
              </div>
              <p style={{ fontSize: '0.9rem', margin: '0.75rem 0 0' }}>{loc.description || 'Raise a ticket for this area.'}</p>
            </Link>
          ))}
        </div>
      )}

      {recent.length > 0 && (
        <>
          <h2 style={{ fontSize: '1.15rem', marginTop: '2rem' }}>Your recent tickets (this device)</h2>
          <div className="tr-card" style={{ padding: 0, overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
              <thead>
                <tr style={{ textAlign: 'left', background: 'var(--bg-muted)' }}>
                  <th style={{ padding: '0.65rem 1rem' }}>Ticket</th>
                  <th style={{ padding: '0.65rem 1rem' }}>Subject</th>
                  <th style={{ padding: '0.65rem 1rem' }}>When</th>
                </tr>
              </thead>
              <tbody>
                {recent.map((r, i) => (
                  <tr key={i} style={{ borderTop: '1px solid var(--border)' }}>
                    <td style={{ padding: '0.65rem 1rem', fontWeight: 600 }}>{r.ticketNumber}</td>
                    <td style={{ padding: '0.65rem 1rem' }}>{r.subject || '—'}</td>
                    <td style={{ padding: '0.65rem 1rem', color: 'var(--text-muted)' }}>{r.at ? new Date(r.at).toLocaleString() : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
